"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderInlineText = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../constants");
const renderInlineText = (value, emptyValue = constants_1.EMPTY_TEXT.dash) => {
    return (react_1.default.createElement(components_1.Text, { whitespace: components_1.TEXT_WHITE_SPACE.normal, style: { wordBreak: 'break-word' } }, value || emptyValue));
};
exports.renderInlineText = renderInlineText;
//# sourceMappingURL=renderInlineText.js.map